var _excluded = ["className", "width", "height", "borderRadius", "data-qa"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { joinCn } from "@ati/uti";
var numberStyleRegExp = /^\d+$/;

/**
 * Skeleton component uses as a placeholder for requested content while it is loading
 */
var Skeleton = _ref => {
  var {
      className,
      width,
      height,
      borderRadius,
      "data-qa": dataQa = "skeleton"
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: joinCn("glz-skeleton", className),
    "data-qa": dataQa,
    style: {
      width,
      height,
      // convert number passed as string to Number for proper styles applying
      borderRadius: typeof borderRadius === "string" && numberStyleRegExp.test(borderRadius) ? Number(borderRadius) : borderRadius
    }
  }, rest));
};
export default Skeleton;